import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PropertyPricingProps {
  propertyType: string;
  salePrice: string;
  rentPrice: string;
  seasonalPrice: string;
  setSalePrice: (value: string) => void;
  setRentPrice: (value: string) => void;
  setSeasonalPrice: (value: string) => void;
}

export function PropertyPricing({
  propertyType,
  salePrice,
  rentPrice,
  seasonalPrice,
  setSalePrice,
  setRentPrice,
  setSeasonalPrice,
}: PropertyPricingProps) {
  return (
    <>
      {propertyType === "sale" && (
        <div className="space-y-2">
          <Label htmlFor="salePrice">Valor de Venda</Label>
          <Input
            id="salePrice"
            value={salePrice}
            onChange={(e) => setSalePrice(e.target.value)}
            placeholder="R$ 000.000,00"
          />
        </div>
      )}

      {propertyType === "rent" && (
        <div className="space-y-2">
          <Label htmlFor="rentPrice">Valor do Aluguel Mensal</Label>
          <Input
            id="rentPrice"
            value={rentPrice}
            onChange={(e) => setRentPrice(e.target.value)}
            placeholder="R$ 0.000,00"
          />
        </div>
      )}

      {propertyType === "seasonal" && (
        <div className="space-y-2">
          <Label htmlFor="seasonalPrice">Valor da Diária</Label>
          <Input
            id="seasonalPrice"
            value={seasonalPrice}
            onChange={(e) => setSeasonalPrice(e.target.value)}
            placeholder="R$ 000,00"
          />
        </div>
      )}
    </>
  );
}